import React from "react";
import { ArrowLeft } from "lucide-react";
import { NavLink } from "react-router-dom";
import MolinosFoto from "../images/Blogs/Molinos.jpg";

// Simulated blog data (in a real app, this would come from an API or database)
const blogPost = {
  id: 1,
  title: "Innovaciones en el transporte de semillas",
  content: `
    <p>El transporte de semillas es un componente crucial en la cadena de suministro agrícola. En los últimos años, hemos sido testigos de avances significativos que están transformando la manera en que movemos y protegemos estas valiosas cargas. Veamos algunas de las innovaciones más destacadas:</p>

    <h2>1. Contenedores con control climático avanzado</h2>
    <p>Los nuevos contenedores inteligentes pueden mantener condiciones óptimas de temperatura y humedad durante todo el trayecto. Estos sistemas no solo regulan el ambiente, sino que también registran datos en tiempo real, permitiendo un monitoreo constante de la calidad de las semillas.</p>

    <h2>2. Tecnología blockchain para trazabilidad</h2>
    <p>La implementación de blockchain en la logística de semillas permite un seguimiento detallado desde el origen hasta el destino final. Esto no solo mejora la transparencia, sino que también ayuda a prevenir fraudes y garantiza la autenticidad de las semillas.</p>

    <h2>3. Drones para inspección y entrega</h2>
    <p>Los drones están siendo utilizados para inspeccionar cargamentos de semillas en grandes almacenes y, en algunas regiones, incluso para entregas de pequeñas cantidades en áreas de difícil acceso.</p>

    <h2>4. Embalajes biodegradables</h2>
    <p>La industria está adoptando materiales de embalaje ecológicos que protegen las semillas tan eficazmente como los plásticos tradicionales, pero sin el impacto ambiental negativo.</p>

    <h2>Conclusión</h2>
    <p>Estas innovaciones no solo están mejorando la eficiencia del transporte de semillas, sino que también están contribuyendo a la sostenibilidad y la calidad del producto final. En Logística Huemul, nos mantenemos a la vanguardia de estas tecnologías para ofrecer el mejor servicio posible a nuestros clientes.</p>
  `,
  date: "2023-09-15",
  author: "Juan Pérez",
  image: MolinosFoto,
};

export default function BlogPost() {
  return (
    <div className="py-12 md:py-24 lg:py-32">
      <div className="container px-4 md:px-6 max-w-3xl mx-auto">
        <NavLink to="/blogs" className="inline-flex items-center text-sm font-medium text-muted-foreground hover:underline mb-6">
          <ArrowLeft className="mr-2 h-4 w-4" />
          Volver a Blogs
        </NavLink>
        <article>
          <img
            src={blogPost.image}
            alt={blogPost.title}
            className="w-full h-[400px] object-cover rounded-lg mb-6"
          />
          <h1 className="text-4xl font-bold tracking-tighter sm:text-5xl mb-4">{blogPost.title}</h1>
          <div className="flex items-center space-x-4 text-sm text-muted-foreground mb-8">
            <p>{blogPost.date}</p>
            <span>•</span>
            <p>Por {blogPost.author}</p>
          </div>
          <div className="prose prose-lg" dangerouslySetInnerHTML={{ __html: blogPost.content }} />
        </article>
      </div>
    </div>
  );
}